import React from "react";

export type TVisibilitySentimentIconProps = React.SVGAttributes<SVGElement>;

export function VisibilitySentimentIcon({
  fill = "currentColor",
  ...rest
}: TVisibilitySentimentIconProps) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...rest}>
      <mask id="mask0_5840_9" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
        <rect width="24" height="24" fill={fill}/>
      </mask>
      <g mask="url(#mask0_5840_9)">
        <path d="M17 21C15.9 21 14.9583 20.6083 14.175 19.825C13.3917 19.0417 13 18.1 13 17C13 15.9 13.3917 14.9583 14.175 14.175C14.9583 13.3917 15.9 13 17 13C18.1 13 19.0417 13.3917 19.825 14.175C20.6083 14.9583 21 15.9 21 17C21 18.1 20.6083 19.0417 19.825 19.825C19.0417 20.6083 18.1 21 17 21ZM7 18C5.9 18 4.95833 17.6083 4.175 16.825C3.39167 16.0417 3 15.1 3 14C3 12.9 3.39167 11.9583 4.175 11.175C4.95833 10.3917 5.9 10 7 10C8.1 10 9.04167 10.3917 9.825 11.175C10.6083 11.9583 11 12.9 11 14C11 15.1 10.6083 16.0417 9.825 16.825C9.04167 17.6083 8.1 18 7 18ZM11 10C9.9 10 8.95833 9.60833 8.175 8.825C7.39167 8.04167 7 7.1 7 6C7 4.9 7.39167 3.95833 8.175 3.175C8.95833 2.39167 9.9 2 11 2C12.1 2 13.0417 2.39167 13.825 3.175C14.6083 3.95833 15 4.9 15 6C15 7.1 14.6083 8.04167 13.825 8.825C13.0417 9.60833 12.1 10 11 10Z" fill="white"/>
      </g>
    </svg>

  );
}
